import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import config from '../config'

const route = config.route
const request = async (task, method, data={}) =>
{
  return axios({
    method,
    url: `${route}/bpjs-api/${task}`,
    data: data,
    headers: { 
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': `Bearer ${localStorage.getItem("token")}`
    },
  })
}

const getToken = async () => {
  return axios({
    method: 'post',
    url: `${route}/auth/login`,
    data: qs.stringify({
      clientId:'ppadmin',
      secret:'p@sarp0l!s'
    }),
    headers: { 
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}

export {request, getToken}


// WEBPACK FOOTER //
// ./src/bpjs-api/authorized-request.js